import React, { useState } from 'react';
import AuthErrorMessage from '../messages/AuthErrorMessage';
import AuthFormLayout from '../layouts/AuthFormLayout';
import AuthNavButton from '../common/AuthNavButton';
import { FloatingLabelInput } from '../common/FloatingLabelInput';

interface SignInFormProps {
  onSubmit: (email: string, password: string) => Promise<void>;
  onSwitchToSignUp: () => void;
  onSwitchToResetPassword: () => void;
  isLoading: boolean;
  error?: string | null;
}

const SignInForm: React.FC<SignInFormProps> = ({
  onSubmit,
  onSwitchToSignUp,
  onSwitchToResetPassword,
  isLoading,
  error,
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(email, password);
  };

  return (
    <AuthFormLayout
      title="Sign in"
      footer={
        <div className="mt-4 text-center">
          <AuthNavButton onClick={onSwitchToSignUp}>Need an account? Sign up</AuthNavButton>
        </div>
      }
      onSubmit={handleSubmit}
    >
      <AuthErrorMessage error={error} />
      <div className="space-y-4">
        <FloatingLabelInput
          label="Email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <FloatingLabelInput
          label="Password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <button
          type="submit"
          disabled={isLoading}
          className="w-full rounded-md border border-gray-300 bg-gray-200 px-4 py-2 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-neutral-500 focus:ring-offset-2 disabled:opacity-50 dark:border-neutral-800 dark:bg-neutral-900 dark:text-white dark:hover:bg-neutral-800"
        >
          {isLoading ? 'Signing in...' : 'Sign in'}
        </button>
        <div className="mt-2 flex justify-center">
          <button
            type="button"
            onClick={onSwitchToResetPassword}
            className="bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-sm font-bold text-transparent"
          >
            Forgot password?
          </button>
        </div>
      </div>
    </AuthFormLayout>
  );
};

export default SignInForm;
